import { render } from "./StopSoundEditorCmp.vue?vue&type=template&id=affc0cc6"
import script from "./StopSoundEditorCmp.vue?vue&type=script&lang=js"
export * from "./StopSoundEditorCmp.vue?vue&type=script&lang=js"

import "./StopSoundEditorCmp.vue?vue&type=style&index=0&id=affc0cc6&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__